var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6747 10.1301C17.6747 8.40138 19.0825 7 20.8191 7C22.5556 7 23.9634 8.40138 23.9634 10.1301C23.9634 11.8587 22.5556 13.2602 20.8191 13.2602C19.9423 13.2602 19.1498 12.9027 18.5801 12.3275L14.2274 15.2911C14.2675 15.4911 14.2887 15.6977 14.2887 15.9087C14.2887 16.3266 14.206 16.7261 14.0563 17.0912L18.8291 20.2269C19.3709 19.7859 20.0639 19.5203 20.8191 19.5203C22.5556 19.5203 23.9634 20.9217 23.9634 22.6504C23.9634 24.3791 22.5556 25.7805 20.8191 25.7805C19.0825 25.7805 17.6747 24.3791 17.6747 22.6504C17.6747 22.1976 17.7717 21.7667 17.9459 21.3775L15.5788 19.8223L13.2117 18.2671C12.6594 18.747 11.936 19.0388 11.1443 19.0388C9.40772 19.0388 8 17.6374 8 15.9087C8 14.18 9.40772 12.7786 11.1443 12.7786C12.1429 12.7786 13.0318 13.242 13.6073 13.963L17.8258 11.0908C17.7277 10.7876 17.6747 10.4646 17.6747 10.1301Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V28C0 30.2091 1.79086 32 4 32H28C30.2091 32 32 30.2091 32 28V4C32 1.79086 30.2091 0 28 0H4ZM5.25 1.25C3.04086 1.25 1.25 3.04086 1.25 5.25V26.75C1.25 28.9591 3.04086 30.75 5.25 30.75H26.75C28.9591 30.75 30.75 28.9591 30.75 26.75V5.25C30.75 3.04086 28.9591 1.25 26.75 1.25H5.25Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d04fdbab53323d400e5e7e5ecd966439.svg";
export { ForwardRef as ReactComponent };